function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "add_box-black-18dp"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M0,0H18.672V18H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M12.444,14H1.555A1.557,1.557,0,0,1,0,12.444V1.555A1.557,1.557,0,0,1,1.555,0H12.444A1.557,1.557,0,0,1,14,1.555V12.444A1.558,1.558,0,0,1,12.444,14ZM2,6V8H6v4H8V8h4V6H8V2H6V6Z",
  transform: "translate(2 2)"
}));

var SvgIconPlusSquare = function SvgIconPlusSquare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Icon_add_box",
    "data-name": "Icon/Icon add_box",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "#878787",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPlusSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-plus-square.d29f5abb.svg";
export { ForwardRef as ReactComponent };